/**
 * ? @description : Unmapped Teachers Data Component
 */

// Dependencies
import React, { useEffect, useState ,useCallback} from "react";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";
import { ShowListInTooltip } from "../../../../Reusable/ShowListInTooltip";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
import { Typography } from "@mui/material";
// import { Box, Button, ClickAwayListener, Menu, MenuItem, Modal, styled, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { ShowFullText } from "../../../../Reusable/ShowMoreText";
import "../../../../../css/categorytab.css";
import axios from "axios";



const ShowFullTextRenderer = (props) => {
  const value = props.data.teacherlanguages;
  // console.log(value);
  return (
    <ShowFullText title={value}>
      <Typography variant='p' sx={{ cursor: "pointer" }}>
        {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
      </Typography>
    </ShowFullText>
  );
};

const ShowFullTextRendererTeacherName = (props) => {
  const value = props.data.teacher_name;
  // console.log(value);
  return (
    <ShowFullText title={value}>
      <Typography variant='p' sx={{ cursor: "pointer" }}>
        {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
      </Typography>
    </ShowFullText>
  );
};
function UnmappedTeachersTable(props) {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [filterData, setFilterData] = useState([]);
  const [teacherCount, setTeacherCount] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  // * Column Definition for the Table Data
  const columnHeader = [
    {
       headerName: "",
       checkboxSelection: true,
       headerCheckboxSelection: true,

     },
    {
      headerName: "Teacher Id",
      field: "teacher_id",
      // filter: true,
      sortable: true,
      hide: true,
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      // filter: true,
      sortable: true,
      cellRendererFramework:'showFullTextRendererTeacher'
    },
    {
      headerName: "No. of students Mapped",
      field: "student_count",
      // filter: true,
      sortable: true,
      cellRenderer: (params) => {
        let id = params.data.teacher_id
        return (
          params.value !== 0 ? <ShowListInTooltip value={params.value} getUrl={`mapping/map/checkmappingteacher/${id}`} property="student_name"></ShowListInTooltip> : "(0)"
        )
      }
    },
    {
      headerName: "Teacher Languages",
      field: "teacherlanguages",
      // filter: true,
      sortable: true,
      cellRendererFramework: 'showFullTextRenderer'
      //   customBodyRender : (value) => {
      //     return(
      //         <ShowFullText title={value}>
      //             <Typography variant='p' sx={{cursor: "pointer"}}>
      //                 {value && value.length > 25 ? `${value.substring(0, 50)}... ` : value}
      //             </Typography>
      //         </ShowFullText>
      //     )
      // }
    },
    { headerName: "Mobile", field: "contactno", 
      // filter: true,
       sortable: true },
    // {headerName: "E-mail", field: "email", filter: true, sortable: true},
    // {headerName: "Batch Status", field: "group_status", filter: true, sortable: true},
    // {headerName: "Batch Id", field: "group_id", filter: true, sortable: true},
    // {headerName: "Batch Name", field: "batch_name", filter: true, sortable: true},
    // {headerName: "Teacher Status", field: "teacher_mapped_status", filter: true, sortable: true},
    // {headerName: "Audio Status", field: "audio_status", filter: true, sortable: true},
    // {headerName: "Role", field: "role", filter: true, sortable: true}
  ];

  // * Row Selection - Multiple
  const rowSelectionType = "multiple";

  // * to show the full language in row 
  const components = {
    showFullTextRenderer: ShowFullTextRenderer,
    showFullTextRendererTeacher: ShowFullTextRendererTeacherName,
  };
  // const componentName ={
  //   showFullTextRendererTeacher: ShowFullTextRendererTeacherName,

  // }

  // * Store Selected Row Data in Props
  const onSelectionChanged = (event) => {
    // console.log(event.api.getSelectedRows());
    props.unmappedteachersdata(event.api.getSelectedRows());
  };

  // * Input Field : Search Box Data
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  // ? Get Method : Data Initializing for the Table
  const onGridReady = (params) => {
    setGridApi(params); // Store the API when the grid is ready
    fetchGridData(params); // Initial data load
  };

  // const fetchGridData = async (params) => {
  //   setFilterData(params.api)
  //   const controller = axios.CancelToken.source();
  //   try {

  //     const teacherData = await Axios("get", "teacher/unmapped/teachers/list", true, null, { cancelToken: controller.token });
  //     const studentCountData = await Axios("get", "mapping/display/studentcount", true, null, { cancelToken: controller.token });

  //     let overallData = teacherData.data.map(teacherItem => {
  //       const index = studentCountData.data.findIndex(studentItem => studentItem.teacher_id === teacherItem.teacher_id)
  //       return index !== -1 ?
  //         {
  //           ...teacherItem,
  //           ...studentCountData.data[index]
  //         } :
  //         {
  //           ...teacherItem,
  //           student_count: 0
  //         }
  //     })
  //     // console.log(overallData);
  //     params.api.setRowData(overallData);
  //   } catch (error) {
  //     if (!axios.isCancel(error)) {
  //       if (error.status === 400) {
  //         params.api.applyTransaction({ add: [] });
  //       } else {
  //         dispatch(
  //           showSnackbar({
  //             message: "Error occurred ! Unable to get teachers data.",
  //             severity: "error",
  //           })
  //         );
  //       }
  //     }

  //   }
  //   return () => {
  //     controller.cancel();
  // }
  // };




// inside your component
const fetchGridData = useCallback(async (params) => {
  setFilterData(params.api);

  const controller = axios.CancelToken.source();

  try {
    const teacherData = await Axios("get", "teacher/unmapped/teachers/list", true, null, {
      cancelToken: controller.token,
    });

    const studentCountData = await Axios("get", "mapping/display/studentcount", true, null, {
      cancelToken: controller.token,
    });

    const overallData = teacherData.data.map((teacherItem) => {
      const match = studentCountData.data.find(
        (studentItem) => studentItem.teacher_id === teacherItem.teacher_id
      );

      return match
        ? { ...teacherItem, ...match }
        : { ...teacherItem, student_count: 0 };
    });

    params.api.setRowData(overallData);
  } catch (error) {
    if (!axios.isCancel(error)) {
      if (error?.status === 400) {
        params.api.applyTransaction({ add: [] });
      } else {
        dispatch(
          showSnackbar({
            message: "Error occurred! Unable to get teachers data.",
            severity: "error",
          })
        );
      }
    }
  }

  // Return cancel function for cleanup (if used in useEffect)
  return () => {
    controller.cancel();
  };
}, [dispatch]); // Add dependencies here as needed (e.g., `dispatch`)


  useEffect(() => {
    if (gridApi) {
    
      fetchGridData(gridApi);
    }
  }, [props.reloadComments, gridApi,fetchGridData]);


  // * Function Call to Get the Count of the Teachers
  useEffect(() => {
    // ? Get Method : Get the Count of the Teachers from the Server
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        let options = {
          method: "GET",
          url: "/mapping/unmappedteacherscount",
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
        // console.log(response.data);
        setTeacherCount(response.data)

      } catch (error) {
        if (!axios.isCancel(error)) {
          dispatch(
            showSnackbar({
              message: "Error occurred ! Unable to get teachers count.",
              severity: "error",
            })
          );
        }

      }
    })()

    return () => {
      controller.cancel();
    }
  }, [dispatch, props.reloadComments]);

  // console.log(teacherCount);
  const teachersCount = () => (
    <p style={{ fontWeight: "600" }}>{teacherCount[0]?.total_teachers}</p>
  );

  return (
    <>
      <div>
        {/* Search Box, Count, Title */}
        <div className="d-flex justify-content-between my-2 table-header" style={{ alignItems: 'center' }}>
          <input
            type="search"
            placeholder="Search"
            onChange={onFilterTextChange}
          />
          <h5 style={{ margin: '0px', display: "flex" }}>Teachers ({teachersCount()})</h5>
          {teacherCount.length > 0 && (
            <h6 style={{ display: "flex", margin: "0px", alignItems: 'center' }}>


              <div style={{ display: "flex", flexDirection: "column", }}><p>Mapped</p> <p>Unmapped</p></div>
              <div style={{ display: "flex", flexDirection: "column", padding: "0 4px", alignItems: 'center' }}><p>-</p> <p>-</p></div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: 'center', fontWeight: "600" }}><p>{teacherCount[0].mapped_teachers}</p> <p>{teacherCount[0].unmapped_teachers}</p></div>

              {/* <div>  - </div>
            
            <div> - </div> */}

            </h6>

          )}
        </div>

        {/* Table */}
        <div
          className="ag-theme-alpine my-2"
          style={{ width: "100%", height: "450px" }}
        >
          <AgGridReact
            defaultColDef={{ flex: 1 }}
            onGridReady={onGridReady}
            columnDefs={columnHeader}
            rowSelection={rowSelectionType}
            onSelectionChanged={onSelectionChanged}
            rowMultiSelectWithClick={true}
            pagination={true}
          
            paginationPageSize={10}
            paginationAutoPageSize={true}
            sideBar={true}
            components={components}
            // components={componentName}
          // rowModelType={'serverSide'} 
          />

        </div>
      </div>
    </>
  );

}


export default UnmappedTeachersTable;
